import React from "react";
import { ChartBarVertical } from "../../../normalizer";
import CustomButton from "../../CustomButton";

const Ranking = ({ className, key, ranking, secondaryText, textColor }) => {
  return (
    <div
      key={key}
      className={`ranking-card-ranking text-xl text-center mb-2 ${secondaryText &&
        "navbar-text"} ${textColor && "text-color"}`}
    >
      <div className={`ranking-card-ranking-name`}>{ranking.name}</div>
      <div className={`$ranking-card-ranking-container`}>
        <span  className={`ranking-card-ranking-posicao`}>
          {ranking.is_winner
            ? ""
            : ranking.position !== "N/A"
            ? `${ranking.position}ª Posição`
            : "-"}
        </span>
        <span className={`ranking-card-ranking-winner`}> 
          {ranking.is_winner 
          ? <CustomButton extrasmall round tight primary>
              <ChartBarVertical width={16} height={16} />
              {ranking.winning_message}
            </CustomButton>
          : null}
        </span>
      </div>
    </div>
  );
};

export default Ranking;
